/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
  					path => router path
  					name => router name
  					component(lazy loading) => component to load
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
    mode: "history",
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        };
    },
    base: process.env.BASE_URL,
    routes: [{
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: "",
            component: () =>
                import ("./layouts/main/Main.vue"),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: "/",
                    redirect: "/login"
                },
                {
                    path: "admin/dashboard",
                    name: "adminDashboard",
                    component: () =>
                        import ("./views/Home.vue")
                },
                {
                    path: "organization/dashboard",
                    name: "organizationDashboard",
                    component: () =>
                        import ("./views/Home.vue")
                },
                {
                    path: "user/dashboard",
                    name: "userDashboard",
                    component: () =>
                        import ("./views/Home.vue")
                },
                {
                    path: "/profile",
                    name: "profile",
                    component: () =>
                        import ("./views/profile.vue")
                },
                {
                    path: "/change-password",
                    name: "changePassword",
                    component: () =>
                        import ("./views/change-password.vue")
                },
                {
                    path: "admin/manage-users",
                    name: "adminManageUsers",
                    component: () =>
                        import ("./views/users/list.vue")
                },
                {
                    path: "admin/manage-organisation",
                    name: "adminManageOrganisation",
                    component: () =>
                        import ("./views/organisation/list.vue")
                },
                {
                    path: "admin/subcription-plan",
                    name: "adminSubcriptionPlan",
                    component: () =>
                        import ("./views/subcriptionPlan/subcriptionPlanList.vue")
                },
                {
                    path: "admin/subcription-plan/add",
                    name: "addSubcriptionPlan",
                    component: () =>
                        import ("./views/subcriptionPlan/addSubcriptionPlan.vue")
                },
                {
                    path: "admin/subcription-plan/view/:id",
                    name: "subcriptionPlanView",
                    component: () =>
                        import ("./views/subcriptionPlan/subcriptionPlanView.vue")
                },
                {
                    path: "admin/subcription-plan/edit/:id",
                    name: "editSubcriptionPlan",
                    component: () =>
                        import ("./views/subcriptionPlan/editSubcriptionPlan.vue")
                },
                {
                    path: "admin/payment-list",
                    name: "adminPaymentList",
                    component: () =>
                        import ("./views/payment/list.vue")
                },

                //  organization

                {
                    path: "organization/manage-users",
                    name: "organizationManageUsers",
                    component: () =>
                        import ("./views/organisation/users/list.vue")
                },
                {
                    path: "/organization/manage-offices",
                    name: "orgManageOffices",
                    component: () =>
                        import ("./views/organisation/offices/list.vue")
                },
                {
                    path: "/organization/manage-departments",
                    name: "orgManageDepartments",
                    component: () =>
                        import ("./views/organisation/departments/list.vue")
                },
                {
                    path: "organization/timesheet",
                    name: "organizationTimesheet",
                    component: () =>
                        import ("./views/organisation/users/userStatusList.vue")
                },
                {
                    path: "organization/v2/timesheet",
                    name: "organizationV2Timesheet",
                    component: () =>
                        import ("./views/organisation/users/user-timesheet.vue")
                },
                {
                    path: "organization/vehicle/timesheet",
                    name: "organizationVehicleTimesheet",
                    component: () =>
                        import ("./views/organisation/users/vehicleTimesheet.vue")
                },
                {
                    path: "organization/manage-vehicles",
                    name: "organizationManageVehicle",
                    component: () =>
                        import ("./views/organisation/vehicle-management.vue")
                },
                {
                    path: "/organization/view-fault",
                    name: "organizationVehicleFault",
                    component: () =>
                        import ("./views/organisation/vehicles/faultlist.vue")
                },
                {
                    path: "organization/settings",
                    name: "organizationSettings",
                    component: () =>
                        import ("./views/organisation/company-settings.vue")
                },
                {
                    path: "organization/quick-pick",
                    name: "organizationQuickpics",
                    component: () =>
                        import ("./views/quickpick/list.vue")
                },
                {
                    path: "organization/payment-list",
                    name: "organizationPaymentList",
                    component: () =>
                        import ("./views/payment/list.vue")
                },

                // user
                {
                    path: "user/timesheet",
                    name: "organizationTimesheet",
                    component: () =>
                        import ("./views/organisation/users/userStatusList.vue")
                },
                {
                    path: "user/v2/timesheet",
                    name: "organizationTimesheet",
                    component: () =>
                        import ("./views/organisation/users/user-timesheet.vue")
                },
                {
                    path: "user/manage-vehicles",
                    name: "userManageVehicle",
                    component: () =>
                        import ("./views/organisation/users/vehicle-list.vue")
                },
                {
                    path: "user/leave",
                    name: "userLeave",
                    component: () =>
                        import ("./views/leave/userleave.vue")
                },
                {
                    path: "organization/leave",
                    name: "Leave",
                    component: () =>
                        import ("./views/leave/hrleave.vue")
                },
                {
                    path: "help-center",
                    name: "HelpCenter",
                    component: () =>
                        import ("./views/HelpCenter.vue")
                }
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: "",
            component: () =>
                import ("@/layouts/full-page/FullPage.vue"),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: "/login",
                    name: "login",
                    component: () =>
                        import ("@/views/pages/Login.vue")
                },
                {
                    path: "/forgot-password",
                    name: "forgotPassword",
                    component: () =>
                        import ("@/views/pages/ForgotPassword.vue")
                },
                {
                    path: "/reset-password",
                    name: "resetPassword",
                    component: () =>
                        import ("@/views/pages/ResetPassword.vue")
                },
                {
                    path: "/error-404",
                    name: "pageError404",
                    component: () =>
                        import ("@/views/pages/Error404.vue")
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: "*",
            redirect: "/error-404"
        }
    ]
});

const checkToken = () => {
    if (localStorage.getItem("authToken") && localStorage.getItem("user")) {
        return true;
    } else {
        return false;
    }
};
router.beforeEach((to, from, next) => {
    if (
        to.name !== "login" &&
        to.name !== "forgotPassword" &&
        to.name !== "resetPassword"
    ) {
        if (checkToken()) {
            next();
        } else {
            //next()
            next({
                name: "login"
            });
        }
    }
    next();
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;